// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { recentWishListsStyles } from "@synd/Overrides/Widgets/Common/RecentWishLists";
import { css } from "styled-components";

recentWishListsStyles.wishListCardsContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
};

recentWishListsStyles.skeletonWrapper = {
    css: css`
        display: grid;
        grid-template-columns: 52px 1fr;
        grid-template-rows: min(17px);
        column-gap: 12px;
        row-gap: 4px;
        align-items: start;
    `,
};

recentWishListsStyles.titledSection = {
    contentContainer: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 12px;
            padding: 12px;
        `,
    },
};
